/**
 * /* eslint-disable no-unused-vars
 *
 * @format
 */

/** @format */

// import { filter } from "lodash";
import React, { useState, useEffect, useRef } from 'react';
// material
import {
  Button,
  Card,
  Container,
  Stack,
  Typography,
  CardContent,
  TextField,
} from '@mui/material';
// components
import Page from '../../components/Page';
//
import { useNavigate, useParams } from 'react-router-dom';
import Iconify from '../../components/Iconify';

// import qs from "qs";
// import { useLocation } from "react-router";
import { Row, Col } from 'react-bootstrap';

import MenuItem from '@mui/material/MenuItem';

import Select from '@mui/material/Select';
import PhoneNumber from '../../dao/PhoneNumber';
import swal from '../../reusables/CustomSwal';
import MessageTemplate from '../../dao/MessageTemplate';
// import DateRangeSelectDialog from "../../components/DateRangeSelectDialog";
import SingleDateSelectDialog from '../../components/SingleDateSelectDialog';

import WhatsappBG from '../../assets/whatsappbg.png';

import moment from 'moment';
// import sampleImage from "../../assets/sampleimg.png";
import ConfirmationDialog from '../../components/ConfirmationDialog';

// import FileUpload from "../../components/FileUpload";
import WAPreviewBody from '../../components/WAPreviewBody';
// import CustomSelectAsync from "src/components/CustomSelectAsync";

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
export default function Broadcast(props) {
  const navigate = useNavigate();
  //   const location = useLocation();

  const { waba_id } = useParams();

  //   const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true });
  const [data, setData] = useState({});
  const [createData, setCreateData] = useState({});
  const [broadcastName, setBroadcastName] = useState('');
  const [broadcastTime, setBroadcastTime] = useState('');
  const [headerImage, setHeaderImage] = useState('');

  const [selectedMessageTemplate, setSelectedMessageTemplate] = useState(null);
  const [selectedPhoneNumber, setSelectedPhoneNumber] = useState('');

  const [numberSelection, setNumberSelection] = useState([]);
  const [messageTemplates, setMessageTemplates] = useState([]);

  const [isSelectingDate, setIsSelectingDate] = useState(false);

  const [dateStart, setDateStart] = useState(new Date(Date.now()));

  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);

  const [loadingUploadTemplate, setLoadingUploadTemplate] = useState(false);
  const [uploadedFileNameExcel, setUploadedFileNameExcel] = useState(null);

  const [loadingUploadHeader, setLoadingUploadHeader] = useState(false);
  const [uploadHeader, setUploadHeader] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [uploadedFileName, setUploadedFileName] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [uploadedFile, setUploadedFile] = useState(null);
  const attachmentRef = useRef();

  useEffect(() => {
    getTemplates();
    getPhoneNumbers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getTemplates = async () => {
    //TODO : Fill with correct WABA ID
    try {
      let results = await MessageTemplate.getAll({ waba_id, limit: 100 });
      // console.log(results);

      let formattedResults = results.data
        .filter((item) => item.status.toLocaleLowerCase() !== 'rejected')
        .map((result) => {
          let header = result.components.find((c) => c.type === 'HEADER');
          let body = result.components.find((c) => c.type === 'BODY');
          let footer = result.components.find((c) => c.type === 'FOOTER');
          let buttons = result.components.find((c) => c.type === 'BUTTONS');

          let phoneNumberUrlArray = [];
          let selectedButtonType = null;
          let quickReplyArray = [];

          if (!!(buttons && buttons.buttons && buttons?.buttons?.length > 0)) {
            buttons = buttons.buttons;

            if (buttons.buttons > 0) {
              let sample = buttons.buttons[0];
              if (sample.type === 'PHONE_NUMBER' || sample.type === 'URL') {
                phoneNumberUrlArray = buttons.buttons;
                selectedButtonType = 'PHONE_NUMBER_URL';
              } else if (sample.type === 'QUICK_REPLY') {
                quickReplyArray = buttons.buttons;
                selectedButtonType = 'QUICK_REPLY';
              }
            }
          }

          return {
            id: result.id,
            content: body.text,
            footer: footer?.text,
            header: header?.format === 'TEXT' ? header.text : null,
            headerFormat: header?.format,
            headerImage: header?.example?.header_handle?.[0] ?? '',
            buttonType: selectedButtonType,
            buttonQuickReply: quickReplyArray,
            buttonPhoneNumberURL: phoneNumberUrlArray,
            name: result.name,
            // content={selectedMessageTemplate.content}
            // footer={selectedMessageTemplate.footer}
            // header={selectedMessageTemplate.header}
            // headerFormat={selectedMessageTemplate.headerFormat}
            // buttonType={selectedMessageTemplate.buttonType}
            // buttonQuickReply={selectedMessageTemplate.buttonQuickReply}
            // buttonPhoneNumberURL={selectedMessageTemplate.buttonPhoneNumberURL}
          };
        });

      // console.log("MTS", formattedResults);
      //let templates = result.map((el) => ({...el.profile, role: el.role}));
      // console.log(formattedResults);

      console.log('formattedResults', formattedResults);
      setMessageTemplates(formattedResults);
    } catch (e) {
      console.log(e);
      // nothing
    }
  };

  const getPhoneNumbers = async () => {
    try {
      //TODO : Fill with correct WABA ID
      let result = await PhoneNumber.getAll(waba_id);
      // console.log("here>>>");
      // console.log(result);
      setNumberSelection(result);
      // console.log(result);
    } catch (e) {
      console.log('ERROR', e);
      await swal.fire({
        title: 'Error',
        text: 'An error has occurred. Please try again later.',
        icon: 'error',
      });
    }
  };

  const uploadFile = (event) => {
    if (!event.target.files || event.target.files.length === 0) {
      return;
    }

    setUploadedFile(URL.createObjectURL(event.target.files[0]));
    setUploadedFileName(event.target.files[0].name);

    // console.log(uploadedFileName);
    /* const file = event.target.files[0]

        console.log(file.name)
        setAttachment(file.name) */
  };

  // const handleUploadFile = () => {
  //   attachmentRef.current.click();
  // };

  const downloadTemplateExcel = async (id) => {
    try {
      const result = await MessageTemplate.getTemplate(waba_id, id);
      const url = window.URL.createObjectURL(new Blob([result]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        'download',
        `Tempalte data ${selectedMessageTemplate.name}.xlsx`
      );
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      console.log(error);
    }
  };

  const handleUploadTemolateClick = async () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel';
    input.onchange = async (e) => {
      try {
        setLoadingUploadTemplate(true);
        const file = e.target.files[0];
        let formData = new FormData();
        formData.append('folder', 'wa_panel');
        formData.append('directory', 'wa_panel');
        formData.append('public', true);
        formData.append('files', file);
        let url = await PhoneNumber.postImage(formData);
        setUploadedFileNameExcel(url.data[0]);
        // setHeader({ ...header, file: url.data[0] });
        setLoadingUploadTemplate(false);

        // console.log("URL HERE>>>");
        // console.log(url.data[0].url);
      } catch (e) {
        setLoadingUploadTemplate(false);
      }
    };
    await input.click();
  };

  const handleSubmitBroadcast = async () => {
    let bodyData = await {};
    let bodyCreatedData = await {};
    if (
      // send later
      broadcastName &&
      waba_id &&
      selectedPhoneNumber &&
      selectedMessageTemplate &&
      uploadedFileNameExcel &&
      broadcastTime.toLocaleLowerCase() === "no" &&
      dateStart
    ) {
      if (moment(dateStart).unix() < moment().unix()) {
        await swal.fire({
          title: "error",
          text: "shchedule time cannot be lower then right now.",
          icon: "error",
        });
        return;
      }
      bodyData = await {
        broadcast_name: broadcastName,
        waba_id: waba_id,
        phone_number: selectedPhoneNumber,
        template_id: selectedMessageTemplate?.id,
        url_data_excel: uploadedFileNameExcel?.url,
        time_schedule: moment(dateStart).unix(),
        status: "scheduled",
      };
      bodyCreatedData = await {
        broadcast_name: broadcastName,
        waba_id: waba_id,
        phone_number: selectedPhoneNumber,
        broadcast_now: false,
        time_schedule: moment(dateStart).unix(),
        template_id: selectedMessageTemplate?.id,
        url_data_excel: uploadedFileNameExcel?.url,
      };
      if (selectedMessageTemplate.headerFormat !== undefined) {
        bodyData["header_url"] = await uploadHeader?.url;
        bodyCreatedData["header_url"] = await uploadHeader?.url;
      }
      await setData({ ...bodyData });
      await setCreateData({ ...bodyCreatedData });

      setConfirmationDialogOpen(true);
    } else if (
      // send now
      broadcastName &&
      waba_id &&
      selectedPhoneNumber &&
      selectedMessageTemplate &&
      uploadedFileNameExcel &&
      broadcastTime.toLocaleLowerCase() === "yes"
    ) {
      bodyData = await {
        broadcast_name: broadcastName,
        waba_id: waba_id,
        phone_number: selectedPhoneNumber,
        template_id: selectedMessageTemplate?.id,
        url_data_excel: uploadedFileNameExcel?.url,
        time_schedule: moment().add(20, "seconds").unix(),
        status: "scheduled",
      };
      bodyCreatedData = await {
        broadcast_name: broadcastName,
        waba_id: waba_id,
        phone_number: selectedPhoneNumber,
        broadcast_now: true,
        template_id: selectedMessageTemplate?.id,
        time_schedule: moment().add(20, "seconds").unix(),
        url_data_excel: uploadedFileNameExcel?.url,
      };
      if (selectedMessageTemplate.headerFormat !== undefined) {
        bodyData["header_url"] = await uploadHeader?.url;
        bodyCreatedData["header_url"] = await uploadHeader?.url;
      }
      await setData({ ...bodyData });
      await setCreateData({ ...bodyCreatedData });
      await setConfirmationDialogOpen(true);
    } else {
      await swal.fire({
        title: "Error",
        text: "Please fill the form",
        icon: "error",
      });
    }
  };

  const changePhoneNumber = (result) => {
    return result.replace(/\D/g, '').replace('-');
  };

  const handleUploadHeader = async () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = typeHeader[selectedMessageTemplate.headerFormat].format;
    input.onchange = async (e) => {
      try {
        setLoadingUploadHeader(true);
        const file = e.target.files[0];
        let formData = new FormData();
        formData.append('folder', 'wa_panel');
        formData.append('directory', 'wa_panel');
        formData.append('public', true);
        formData.append('files', file);
        let url = await PhoneNumber.postImage(formData);
        setHeaderImage(url.data[0].url);
        setUploadHeader(url.data[0]);

        setLoadingUploadHeader(false);
      } catch (e) {
        setLoadingUploadHeader(false);
      }
    };
    await input.click();
  };

  const typeHeader = {
    IMAGE: {
      text: 'Choose Image',
      warning: 'PNG or JPG image format and max size 1.5 MB',
      format: 'image/jpeg,image/png',
    },
    DOCUMENT: {
      text: 'Choose PDF',
      warning: 'PDF format',
      format: 'application/pdf',
    },
    VIDEO: {
      text: 'Choose Video',
      warning: 'MP4 video format and max size 64.0 MB',
      format: 'video/mp4',
    },
    TEXT: {
      text: 'Choose TEXT',
      warning: 'TEXT format',
    },
  };

  // console.log('selectedMessageTemplate', selectedMessageTemplate);

  return (
    <Page title="Broadcast">
      <Container>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
          }}
        >
          <div
            onClick={() => {
              navigate('/broadcast');
            }}
            style={{
              cursor: 'pointer',
            }}
          >
            <Iconify
              width={60}
              height={60}
              color={'#DBDBDB'}
              icon="ion:arrow-back-circle"
              sx={{ marginRight: 1 }}
            />
          </div>

          <Stack direction="column" justifyContent="center">
            <Typography variant="h4">Create Broadcast</Typography>
          </Stack>
        </div>

        <div
          style={{ fontSize: '1.2em', marginTop: '1em', marginBottom: '1em' }}
        >
          Broadcast Details
        </div>

        <Card>
          <CardContent>
            <Row>
              <Col md={8}>
                <div
                  style={{
                    borderRight: '1px solid #25252520',
                    paddingLeft: 10,
                    paddingRight: 10,
                  }}
                >
                  <Row>
                    <Col md={6}>
                      <div
                        style={{
                          color: '#8E8EA1',
                          marginBottom: 10,
                          marginTop: 10,
                        }}
                      >
                        Broadcast Name
                      </div>
                      <TextField
                        hiddenLabel={true}
                        fullWidth
                        value={broadcastName}
                        onChange={(e) => {
                          setBroadcastName(e.target.value);
                        }}
                        InputLabelProps={{ shrink: false }}
                        sx={{
                          '& legend': { display: 'none' },
                          '& fieldset': { top: 0 },
                        }}
                      />
                    </Col>
                    <Col md={6}>
                      <div
                        style={{
                          color: '#8E8EA1',
                          marginBottom: 10,
                          marginTop: 10,
                        }}
                      >
                        Broadcast Now
                      </div>
                      <Select
                        style={{ width: '100%' }}
                        // labelId="demo-simple-select-label"
                        // id="demo-simple-select"
                        value={broadcastTime}
                        onChange={(e) => {
                          setBroadcastTime(e.target.value);
                        }}
                        sx={{
                          '& legend': { display: 'none' },
                          '& fieldset': { top: 0 },
                        }}
                      >
                        <MenuItem value="none" selected disabled>
                          Please select a time.
                        </MenuItem>
                        <MenuItem value={'No'}>No</MenuItem>
                        <MenuItem
                          onClick={() => {
                            setDateStart(new Date().getTime());
                          }}
                          value={'Yes'}
                        >
                          Yes
                        </MenuItem>
                      </Select>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <div
                        style={{
                          color: '#8E8EA1',
                          marginBottom: 10,
                          marginTop: 10,
                        }}
                      >
                        Message Template
                      </div>
                      <Select
                        style={{ width: '100%' }}
                        // labelId="demo-simple-select-label"
                        // id="demo-simple-select"
                        value={selectedMessageTemplate}
                        onChange={(e) => {
                          // console.log("MTS", e.target.value);
                          setSelectedMessageTemplate(e.target.value);

                          // headerFormat: header?.format,
                          // headerImage: header?.example?.header_handle?.[0] ?? '',
                          if (e.target.value.headerFormat === 'IMAGE') {
                            setHeaderImage(e.target.value.headerImage);
                          }
                          // setHeaderImage
                        }}
                        sx={{
                          '& legend': { display: 'none' },
                          '& fieldset': { top: 0 },
                        }}
                      >
                        <MenuItem value="none" selected disabled>
                          Please select an item.
                        </MenuItem>
                        {messageTemplates.map((obj) => {
                          return <MenuItem value={obj}>{obj.name}</MenuItem>;
                        })}
                      </Select>
                    </Col>
                    <Col md={6}>
                      <div
                        style={{
                          color: '#8E8EA1',
                          marginBottom: 10,
                          marginTop: 10,
                        }}
                      >
                        Date Start
                      </div>
                      <TextField
                        disabled={broadcastTime === 'Yes'}
                        type="datetime-local"
                        // InputProps={{
                        //   startAdornment: (
                        //     <InputAdornment position="start">
                        //       <IconButton
                        //         disabled={broadcastTime === "Yes"}
                        //         edge="start"
                        //       >
                        //         <Iconify
                        //           color={"#6260dc"}
                        //           icon={
                        //             "material-symbols:calendar-today-rounded"
                        //           }
                        //         />
                        //       </IconButton>
                        //     </InputAdornment>
                        //   ),
                        // }}
                        hiddenLabel={true}
                        fullWidth
                        value={moment(dateStart).format('YYYY-MM-DDTHH:mm')}
                        onChange={(e) => {
                          setDateStart(new Date(e.target.value).getTime());
                        }}
                        InputLabelProps={{ shrink: false }}
                        sx={{
                          '& legend': { display: 'none' },
                          '& fieldset': { top: 0 },
                        }}
                      />
                      {/* <TextField
                        disabled={broadcastTime === "Yes"}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <IconButton
                                disabled={broadcastTime === "Yes"}
                                edge="start"
                              >
                                <Iconify
                                  color={"#6260dc"}
                                  icon={
                                    "material-symbols:calendar-today-rounded"
                                  }
                                />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        onMouseDown={() => {
                          if (broadcastTime !== "Yes") {
                            setIsSelectingDate(true);
                          }
                        }}
                        hiddenLabel={true}
                        fullWidth
                        value={moment(dateStart).format("DD MMM YYYY")}
                        InputLabelProps={{ shrink: false }}
                        sx={{
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                      /> */}
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <div
                        style={{
                          color: '#8E8EA1',
                          marginBottom: 10,
                          marginTop: 10,
                        }}
                      >
                        Phone Sender
                      </div>
                      <Select
                        style={{ width: '100%' }}
                        // labelId="demo-simple-select-label"
                        // id="demo-simple-select"
                        value={selectedPhoneNumber}
                        onChange={(e) => {
                          setSelectedPhoneNumber(e.target.value);
                        }}
                        sx={{
                          '& legend': { display: 'none' },
                          '& fieldset': { top: 0 },
                        }}
                      >
                        <MenuItem value="none" selected disabled>
                          Please select an item.
                        </MenuItem>
                        {numberSelection.map((obj) => {
                          return (
                            <MenuItem
                              value={changePhoneNumber(
                                obj.display_phone_number
                              )}
                            >
                              {obj.display_phone_number}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </Col>
                    {selectedMessageTemplate?.headerFormat !== undefined &&
                      selectedMessageTemplate?.headerFormat !== 'TEXT' && (
                        <Col md={6}>
                          <div
                            style={{
                              color: '#8E8EA1',
                              marginBottom: 10,
                              marginTop: 10,
                              textTransform: 'capitalize',
                            }}
                          >
                            {`Upload Header ${
                              selectedMessageTemplate?.headerFormat.toLocaleLowerCase() ??
                              ''
                            }`}
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'flex-end',
                            }}
                          >
                            <input
                              onChange={(event) => handleUploadHeader(event)}
                              type="file"
                              ref={attachmentRef}
                              style={{ display: 'none' }}
                              // accept={[".xls", ".xlsx", ".csv"]}
                            />
                            <Button
                              onClick={() => handleUploadHeader()}
                              style={{
                                height: 60,
                                width: '100%',
                                color: 'black',
                                fontWeight: 400,
                                fontSize: '1em',
                                background: '#f5f5f5',
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'center',
                                borderRadius: 20,
                                paddingRight: 30,
                                marginRight: 0,
                                boxShadow: 'none',
                              }}
                              disabled={loadingUploadHeader}
                            >
                              <div
                                style={{
                                  fontWeight: 500,
                                  display: 'flex',
                                  //alignItems: "center",
                                  flexDirection: 'row',
                                }}
                              >
                                <div
                                  style={{
                                    background: '#6260dc',
                                    height: '1.5em',
                                    width: '1.5em',
                                    borderRadius: '1em',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginRight: 15,
                                    marginLeft: 6,
                                    fontSize: '0.9em',
                                  }}
                                >
                                  <Iconify
                                    color={'white'}
                                    icon={'ic:outline-file-upload'}
                                  />
                                </div>
                                {loadingUploadHeader
                                  ? 'Loading...'
                                  : 'Upload Data'}
                              </div>
                            </Button>
                          </div>
                          {uploadHeader && (
                            <Button
                              style={{
                                border: '1px solid #6260dc',
                                height: 40,
                                width: '100%',
                                color: 'black',
                                fontWeight: 400,
                                fontSize: '0.8em',
                                marginTop: 10,
                                background: 'white',
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'center',
                                alignItems: 'center',
                                borderRadius: 20,
                                paddingRight: 10,
                                textTransform: 'none',
                              }}
                            >
                              <a
                                href={uploadHeader.url}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                  }}
                                >
                                  <div
                                    style={{
                                      background: '#6260dc',
                                      height: '2em',
                                      width: '2em',
                                      borderRadius: '2em',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      marginRight: 6,
                                    }}
                                  >
                                    <Iconify
                                      color={'white'}
                                      icon={'mdi:paper-outline'}
                                    />
                                  </div>
                                  <div
                                    style={{
                                      fontSize: '0.8em',
                                    }}
                                  >
                                    {uploadHeader.fileName}
                                  </div>
                                </div>
                              </a>
                              <Iconify
                                onClick={() => {
                                  setUploadHeader(null);
                                  // setUploadedFileName(null);
                                  // setUploadedFile(null);
                                }}
                                color={'grey'}
                                icon={'uil:times'}
                              />
                            </Button>
                          )}
                        </Col>
                      )}
                    <Col md={6}>
                      <div
                        style={{
                          color: '#8E8EA1',
                          marginBottom: 10,
                          marginTop: 10,
                        }}
                      >
                        Upload CSV
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'flex-end',
                        }}
                      >
                        <input
                          onChange={(event) => uploadFile(event)}
                          type="file"
                          ref={attachmentRef}
                          style={{ display: 'none' }}
                          accept={['.xls', '.xlsx', '.csv']}
                        />
                        <Button
                          onClick={() => handleUploadTemolateClick()}
                          style={{
                            height: 60,
                            width: '100%',
                            color: 'black',
                            fontWeight: 400,
                            fontSize: '1em',
                            background: '#f5f5f5',
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'center',
                            borderRadius: 20,
                            paddingRight: 30,
                            marginRight: 0,
                            boxShadow: 'none',
                          }}
                          disabled={loadingUploadTemplate}
                        >
                          <div
                            style={{
                              fontWeight: 500,
                              display: 'flex',
                              //alignItems: "center",
                              flexDirection: 'row',
                            }}
                          >
                            <div
                              style={{
                                background: '#6260dc',
                                height: '1.5em',
                                width: '1.5em',
                                borderRadius: '1em',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginRight: 15,
                                marginLeft: 6,
                                fontSize: '0.9em',
                              }}
                            >
                              <Iconify
                                color={'white'}
                                icon={'ic:outline-file-upload'}
                              />
                            </div>
                            {loadingUploadTemplate
                              ? 'Loading...'
                              : 'Upload Data'}
                          </div>
                        </Button>
                      </div>
                      {uploadedFileNameExcel && (
                        <Button
                          style={{
                            border: '1px solid #6260dc',
                            width: '100%',
                            height: 40,
                            color: 'black',
                            fontWeight: 400,
                            fontSize: '0.8em',
                            marginTop: 10,
                            marginBottom: 10,
                            background: 'white',
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'center',
                            alignItems: 'center',
                            borderRadius: 20,
                            paddingRight: 10,
                            textTransform: 'none',
                          }}
                        >
                          <a download href={uploadedFileNameExcel.url}>
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                              }}
                            >
                              <div
                                style={{
                                  background: '#6260dc',
                                  height: '2em',
                                  width: '2em',
                                  borderRadius: '2em',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  marginRight: 6,
                                }}
                              >
                                <Iconify
                                  color={'white'}
                                  icon={'mdi:paper-outline'}
                                />
                              </div>
                              <div
                                style={{
                                  fontSize: '0.8em',
                                }}
                              >
                                {uploadedFileNameExcel.fileName}
                              </div>
                            </div>
                          </a>
                          <Iconify
                            onClick={() => {
                              setUploadedFileNameExcel(null);
                              // setUploadedFileName(null);
                              // setUploadedFile(null);
                            }}
                            color={'grey'}
                            icon={'uil:times'}
                          />
                        </Button>
                      )}

                      <div
                        style={{
                          color: selectedMessageTemplate?.id
                            ? '#6260dc'
                            : '#cecece',
                          fontSize: '0.65em',
                          cursor: 'pointer',
                        }}
                        onClick={() => {
                          if (selectedMessageTemplate?.id)
                            downloadTemplateExcel(selectedMessageTemplate?.id);
                        }}
                      >
                        Download sample data template for sending broadcast
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    {/* <Col md={6}>
                      <div
                        style={{
                          color: "#8E8EA1",
                          marginBottom: 10,
                          marginTop: 10,
                        }}
                      >
                        Header Template
                      </div>
                      <Button
                        style={{
                          height: 60,
                          color: "#8e8ea1",
                          fontWeight: 400,
                          fontSize: "1em",
                          background: "#f5f5f5",
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "left",
                          borderRadius: 20,
                          paddingRight: 30,
                          width: "50%",
                          paddingLeft: 20,
                        }}
                      >
                        Image
                      </Button>
                    </Col> */}
                    <Col
                      style={{
                        display: 'flex',
                        alignItems: 'flex-end',
                        paddingTop: 40,
                      }}
                      md={6}
                    >
                      <Button
                        onClick={() => {
                          handleSubmitBroadcast();
                        }}
                        variant="contained"
                        fullWidth
                        style={{
                          height: '100%',
                          borderRadius: 20,
                          fontFamily: 'Inter',
                          fontWeight: 400,
                          fontSize: '1.05em',
                        }}
                      >
                        Send Broadcast&nbsp;&nbsp;
                        <Iconify
                          style={{ fontSize: '1.2em' }}
                          onClick={() => {}}
                          color={'grey'}
                          icon={'carbon:send'}
                        />
                      </Button>
                    </Col>
                  </Row>
                </div>
              </Col>
              <Col md={4}>
                <div
                  style={{
                    width: '100%',
                    height: 500,
                    display: 'flex',
                    flexDirection: 'column',
                    background: `url("${WhatsappBG}")`,
                    backgroundSize: 'cover',
                  }}
                >
                  <div
                    style={{
                      background: 'white',
                      borderRadius: '20px 20px 0 0',
                      borderTop: '1px solid #8e8ea1',
                      fontWeight: 'bold',
                      color: '#8e8ea1',
                      paddingLeft: 20,
                      paddingBottom: 15,
                      paddingTop: 15,
                    }}
                  >
                    Preview Broadcast
                  </div>

                  <div style={{ overflowY: 'scroll', flex: 1 }}>
                    <div
                      style={{
                        width: '85%',
                        paddingLeft: '5%',
                        paddingBottom: 30,
                      }}
                    >
                      {selectedMessageTemplate && (
                        <WAPreviewBody
                          content={selectedMessageTemplate.content}
                          footer={selectedMessageTemplate.footer}
                          header={selectedMessageTemplate.header}
                          headerFormat={selectedMessageTemplate.headerFormat}
                          headerImage={headerImage}
                          buttonType={selectedMessageTemplate.buttonType}
                          buttonQuickReply={
                            selectedMessageTemplate.buttonQuickReply
                          }
                          buttonPhoneNumberURL={
                            selectedMessageTemplate.buttonPhoneNumberURL
                          }
                        />
                      )}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </CardContent>
        </Card>
      </Container>
      <SingleDateSelectDialog
        open={isSelectingDate}
        onClose={() => {
          // alert("is selecting date" + isSelectingDate)
          setIsSelectingDate(false);
        }}
        date={dateStart}
        setDate={(value) => setDateStart(value)}
      />
      <ConfirmationDialog
        // here
        createData={createData}
        sendData={data}
        open={confirmationDialogOpen}
        onClose={() => {
          setConfirmationDialogOpen(false);
          // alert("is selecting date" + isSelectingDate)
        }}
      />
    </Page>
  );
}
